import ResearchFiltering from 'src/javascripts/components/ResearchFiltering';

export default class AccountsResearchControversiesIndex {

  constructor() {}

  render() {

    // Filtering functions
    ResearchFiltering();

  }

}